var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.tag,
    _vm._g({ tag: "component", staticClass: "_bdg" }, _vm.listeners),
    [
      _vm._t("default"),
      _c(
        "transition",
        {
          attrs: { name: "_tr-scale", appear: "" },
          on: { "after-leave": _vm.reset }
        },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.value,
                  expression: "value"
                }
              ],
              staticClass: "_bdgw",
              class: ((_obj = { _bdgi: !_vm.$slots.default }),
              (_obj["bg-" + _vm.tone] = _vm.tone),
              (_obj["_e" + _vm.appearance] = _vm.appearance),
              _obj),
              style: _vm.style,
              attrs: {
                "aria-atomic": "true",
                "aria-label": _vm.$locale.data.Badge,
                "aria-live": "polite",
                role: "status"
              }
            },
            [_vm._t("label", [_vm._v(_vm._s(_vm.ivalue))])],
            2
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }